import React, { useState } from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import useAuth from '../hooks/UseAuth'
import { Navigate } from "react-router-dom";
import BgLogin from "../../assets/bg-login.png";
import SifLogo from "../../assets/sif-logo.svg";
import UpjLogo from "../../assets/upj-logo.svg";
import GoogleLogo from "../../assets/google-logo.svg";
import CartoonLogin from "../../assets/home-cartoon.svg";
import "../styles/loginClient.css";

const Login = () => {
  const { isLoggedIn, user, signInWithGoogle } = useAuth();
  const [loading, setLoading] = useState(false);
  
  if (isLoggedIn || user) {
    return <Navigate to="/home"  />;
  }

  // Handle Google sign-in
  const handleSignIn = async () => {
    setLoading(true);
    try {
      await signInWithGoogle();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="p-0" id="login-container">
      <Row className="gx-0 min-vh-100">
        {/* Column for large screens */}
        <Col md={6} className="position-relative d-none d-md-flex flex-column">
          <Image
            src={BgLogin}
            className="position-absolute w-100 h-100"
            id="login-bg "
          />
          <div className="d-flex align-items-center" id="login-logo">
            <Image src={UpjLogo} fluid width={40} />
            <Image src={SifLogo} fluid className="ms-3" width={40} />
          </div>
        </Col>

        <Col
          md={6}
          className="d-flex flex-column text-center align-items-center justify-content-md-center"
        >
          {/* Logo div for small screens */}
          <div className="d-flex d-md-none justify-content-start align-items-center py-3">
            <Image src={UpjLogo} fluid width={35} />
            <Image src={SifLogo} fluid className="ms-3" width={40} />
          </div>

          <div className="py-md-2 py-3">
            <h1 id="login-heading">
              Tunjukan Jati Dirimu: Temukan Potensi dengan Tes Kepribadian Kami!
            </h1>
          </div>
          <div className="py-2 py-md-0">
            <Image src={CartoonLogin} id="login-cartoon" fluid  />
          </div>
          <div className="divider pt-4 pb-3">Sign In With</div>
          <div className="d-flex flex-column justify-content-center align-items-center gap-3">
            <Button
              className="d-flex justify-content-center align-items-center gap-3"
              id="btn-google"
              onClick={handleSignIn}
              disabled={loading}
            >
               {loading ? (
                "Signing In..."
              ) : (
                <>
                  <img src={GoogleLogo} alt="Google Logo" width={25} /> Sign
                  In With Google
                </>
              )}
            </Button>
            <p>
              Mengalami Kendala ? <a href="#">Hubungi Kami</a>
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
